export const emptyFunction = () => {
  // empty
}

export const PROJECT = 'demo'
